
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import ImageUploader from "../tools/uploaderImage"

import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import HeaderOfPage from "../tools/headerOfPage";

// Helper function to get multilingual value
const getMultilingualValue = (field: any, lang: string = 'en'): string => {
    if (!field) return '';
    if (typeof field === 'string') return field;
    if (typeof field === 'object') {
        return field[lang] || field.en || field.ku || field.fa || field.ar || field.tr || '';
    }
    return '';
};

export default function ListGallery() {
    const { t } = useTranslation();
    const [languages, setLanguages] = useState<Array<{ code: string; label: string }>>([]);

    const loadLanguages = async () => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data?.message ?? [];
            const mapped = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged ?? 0) - (b.arranged ?? 0))
                .map((lang: any) => ({ code: lang.code, label: lang.label }));
            setLanguages(mapped);
        } catch (e) {
            console.error('Error loading languages:', e);
            setLanguages([
                { code: 'ku', label: 'Kurdish' },
                { code: 'fa', label: 'فارسی' },
                { code: 'en', label: 'English' },
                { code: 'ar', label: 'العربية' },
                { code: 'tr', label: 'Türkçe' }
            ]);
        }
    };

    useEffect(() => {
        loadLanguages();
    }, []);

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Gallery',
            url: '/dashboard/Gallery'
        },
        {
            name: 'Gallery List',
            url: null
        },
    ]
    const [key, setKey] = useState<any>(1);
    const reloadgame = () => setKey((prev: number) => prev + 1);

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6 directions">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="لیست گالری" />

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-5 gap-6 items-start">
                <div className="sm:col-span-1">
                    <NewBlogCategory reloaditem={reloadgame} languages={languages} />
                </div>
                <div className="sm:col-span-4">
                    <ListofBlog key={key} languages={languages} />
                </div>
            </div>
        </div>
    )
}
function ListofBlog({ languages = [] }: { languages?: Array<{ code: string; label: string }> }) {
    const { t } = useTranslation();
    const langList = languages.length > 0 ? languages : [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];
    const [currentLang, setCurrentLang] = useState<string>(langList[0]?.code ?? i18next.language ?? 'en');

    let cookie = getCookies();
    const [list, setList] = useState<any[]>([]);
    const [filtered, setFiltered] = useState<any[]>([]);
    const [search, setSearch] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const getalldata = async () => {
        try {
            setLoading(true);
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/gallery',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            const items = res.data.message || [];
            setList(items);
            setFiltered(items);
        } catch (error: any) {
            console.error('Error loading galleries', error);
        } finally {
            setLoading(false);
        }
    }
    const deleted = async (id: any) => {
        Swal.fire({
            title: t('Are you sure?'),
            text: t('Delete this Group!'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/gallery/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    getalldata();
                } catch (error) {
                    console.log(error);
                }
            }
        });

    }
    useEffect(() => {
        getalldata();
    }, []);

    useEffect(() => {
        if (!search) {
            setFiltered(list);
        } else {
            const s = search.toLowerCase();
            setFiltered(
                list.filter((item: any) => {
                    const name = getMultilingualValue(item.name, currentLang);
                    const url = item.url || '';
                    return name.toLowerCase().includes(s) || url.toLowerCase().includes(s);
                })
            );
        }
    }, [search, list, currentLang]);
    return (
        <div className="bg-white rounded-xl shadow-sm p-4 md:p-6">
            <div className="flex flex-col md:flex-row md:items-center gap-3 justify-between mb-4" dir="rtl">
                <div className="flex items-center gap-2">
                    <button
                        type="button"
                        onClick={() => getalldata()}
                        className="inline-flex items-center gap-x-2 px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v6h6M20 20v-6h-6M5 19a9 9 0 0114-7.5M19 5a9 9 0 00-14 7.5" />
                        </svg>
                        {t('Reload')}
                    </button>
                </div>

                <div className="w-full md:w-72">
                    <input
                        type="text"
                        className="py-2.5 px-3 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="جستجو بر اساس نام یا آدرس..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>

            {loading ? (
                <div className="flex items-center justify-center py-10">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                </div>
            ) : (
                <div className="flex flex-col text-right">
                    {/* Language Selector */}
                    <div className="mb-4 flex items-center gap-3">
                        <span className="text-sm font-medium text-gray-700">زبان نمایش / Display Language:</span>
                        <div className="flex gap-2 flex-wrap">
                            {langList.map((lang) => (
                                <button
                                    key={lang.code}
                                    type="button"
                                    onClick={() => setCurrentLang(lang.code)}
                                    className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                        currentLang === lang.code
                                            ? 'bg-blue-600 text-white'
                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                    }`}
                                >
                                    {lang.label}
                                </button>
                            ))}
                        </div>
                    </div>
                    
                    <div className="-m-1.5 overflow-x-auto">
                        <div className="p-1.5 min-w-full inline-block align-middle">
                            <div className="overflow-hidden border border-gray-200 rounded-xl">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th scope="col" className="px-6 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                                {t('Name')} ({langList.find(l => l.code === currentLang)?.label})
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">{t('SLUG')}</th>
                                            <th scope="col" className="px-6 py-3 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">{t('Action')}</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                        {filtered.map((item: any) => (
                                            <tr key={item.id} className="hover:bg-gray-50">
                                                <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-800">
                                                    {getMultilingualValue(item.name, currentLang)}
                                                </td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-600">{item.url}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-center text-sm font-medium">
                                                    <div className="flex items-center justify-center gap-2">
                                                        <a
                                                            href={`/dashboard/Gallery/gallery/${item.id}`}
                                                            className="inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-blue-50"
                                                        >
                                                            <img src="/icons/editgreen.svg" width={18} alt="Edit" />
                                                        </a>
                                                        <button
                                                            onClick={() => deleted(item.id)}
                                                            type="button"
                                                            className="inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-red-50"
                                                        >
                                                            <img src="/icons/delred.svg" width={18} alt="Del" />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}

                                        {filtered.length === 0 && (
                                            <tr>
                                                <td colSpan={3} className="px-6 py-6 text-center text-sm text-gray-500">
                                                    گالری‌ای برای نمایش وجود ندارد.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
type MultilingualField = Record<string, string>;

const initializeMultilingualField = (field: any, languageCodes: string[]): MultilingualField => {
    if (!field) {
        const obj: MultilingualField = {};
        languageCodes.forEach(code => obj[code] = '');
        return obj;
    }
    if (typeof field === 'string') {
        const obj: MultilingualField = {};
        languageCodes.forEach(code => obj[code] = field);
        return obj;
    }
    if (typeof field === 'object') {
        const obj: MultilingualField = { ...field };
        languageCodes.forEach(code => { if (obj[code] == null) obj[code] = ''; });
        return obj;
    }
    const obj: MultilingualField = {};
    languageCodes.forEach(code => obj[code] = '');
    return obj;
};

function NewBlogCategory({ reloaditem, languages = [] }: { reloaditem: () => void; languages?: Array<{ code: string; label: string }> }) {
    const { t } = useTranslation();
    const langList = languages.length > 0 ? languages : [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];
    const languageCodes = langList.map(l => l.code);

    let cookie = getCookies();
    const [data, setData] = useState<any>({
        name: {} as MultilingualField,
        url: '',
        keywords: {} as MultilingualField,
        description: {} as MultilingualField,
        parent: null
    });
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const [activeLang, setActiveLang] = useState<string>(langList[0]?.code ?? 'en');

    useEffect(() => {
        if (languageCodes.length === 0) return;
        setData((prev: any) => ({
            ...prev,
            name: initializeMultilingualField(prev.name, languageCodes),
            keywords: initializeMultilingualField(prev.keywords, languageCodes),
            description: initializeMultilingualField(prev.description, languageCodes),
        }));
        if (langList[0]) setActiveLang(langList[0].code);
    }, [languageCodes.join(',')]);

    const getMultilingualValue = (field: MultilingualField, lang: string): string => {
        return (field && field[lang]) || '';
    };

    const setName = (name: string) => {
        const updatedName = { ...data.name, [activeLang]: name };
        let newUrl = data.url;
        if (activeLang === 'en') {
            newUrl = String(changeUrl(name));
        }
        setData({ ...data, url: newUrl, name: updatedName });
    }
    const save = async () => {
        setError(null);

        try {
            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/gallery',
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data;
            const empty: MultilingualField = {};
            languageCodes.forEach(code => empty[code] = '');
            setData({
                name: { ...empty },
                url: '',
                keywords: { ...empty },
                description: { ...empty },
                parent: null
            });
            reloaditem();
            let x = key + 1;
            setKey(x);
            return mydata;
        } catch (error: any) {

            error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            setError(error.response.data.message.errors);
        }
    }

    const inputstyle = "py-2.5 px-3 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white";
    return (
        <div className="bg-white rounded-xl shadow-sm p-4 text-right" dir="rtl">
            <h4 className="text-[18px] font-semibold text-gray-800 mb-1">{t('New Gallery')}</h4>
            <p className="text-xs text-gray-500 mb-4">یک گالری جدید با نام و آدرس یکتا ایجاد کنید.</p>

            <form key={key} className="space-y-4">
                {/* Language Selector */}
                <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">زبان / Language</label>
                    <div className="flex gap-2 flex-wrap">
                        {langList.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                onClick={() => setActiveLang(lang.code)}
                                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                    activeLang === lang.code
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">{t('Gallery')} ({langList.find(l => l.code === activeLang)?.label})</label>
                    <input
                        type="text"
                        value={getMultilingualValue(data.name, activeLang)}
                        className={`${inputstyle}     ${error != null && error['name'] != undefined && `bg-red-100`} `}
                        placeholder="نام گالری"
                        onChange={(e) => { setName(e.target.value); }}
                    />
                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                </div>
                <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">{t('Slug')}</label>
                    <input
                        value={data.url}
                        type="text"
                        className={`${inputstyle}       ${error != null && error['url'] != undefined && `bg-red-100`}  `}
                        placeholder="مثال: gallery-name"
                        onChange={(e) => setData({ ...data, url: e.target.value })}
                    />
                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                </div>
                <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">{t('Keywords')} ({langList.find(l => l.code === activeLang)?.label})</label>
                    <textarea
                        value={getMultilingualValue(data.keywords, activeLang)}
                        className={inputstyle}
                        onChange={(e) => setData({ 
                            ...data, 
                            keywords: { 
                                ...data.keywords, 
                                [activeLang]: e.target.value 
                            } 
                        })}
                        placeholder="..." />
                </div>
                <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">{t('Description')} ({langList.find(l => l.code === activeLang)?.label})</label>
                    <textarea
                        value={getMultilingualValue(data.description, activeLang)}
                        className={inputstyle}
                        onChange={(e) => setData({ 
                            ...data, 
                            description: { 
                                ...data.description, 
                                [activeLang]: e.target.value 
                            } 
                        })}
                        placeholder="..." />
                </div>
                <div className="pt-2">
                    <button
                        type="button"
                        onClick={(e) => { save() }}
                        className="w-full py-2.5 px-4 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
                    >
                        {t('Add Gallery')}
                    </button>
                </div>
            </form>
        </div>
    )
}